module.exports = __webpack_public_path__ + "static/img/企业文化5.04887b78.png";